module.exports = __webpack_public_path__ + "static/media/sourcesanspro-regular-webfont.998d95f8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-regular-webfont.ttf
// module id = 499
// module chunks = 0